import React, { ComponentProps, ReactNode } from 'react';
import { Card } from '@/components/ui/Card';
import { cn } from '@/utils';
import { SkillRail } from './SkillRail';

type SkillRailProps = ComponentProps<typeof SkillRail>;

export interface EmbeddedSkillRailProps extends SkillRailProps {
  children?: ReactNode;
  cardClassName?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

/**
 * In-page skill rail wrapped in a subtle card — matches the Live tab pattern:
 * collapsed by default, placed after primary controls and before main content.
 */
export function EmbeddedSkillRail({
  children,
  cardClassName,
  padding = 'sm',
  className,
  gridClassName,
  ...skillRailProps
}: EmbeddedSkillRailProps) {
  return (
    <Card
      padding={padding}
      className={cn(
        'border border-khiimori-border/50 bg-khiimori-bg-elevated/25',
        cardClassName,
      )}
    >
      <SkillRail className={cn('my-0', className)} gridClassName={gridClassName} {...skillRailProps} />
      {children}
    </Card>
  );
}

export default EmbeddedSkillRail;
